import {BaseLayout} from "../components/misc";
import {useForm} from "react-hook-form";
import {SummaryTable} from "../components";


export default function SummaryScreen(props) {
  const {register, handleSubmit, watch} = useForm({
    defaultValues: {
      color: 'standard'
    }
  });
  const color = watch('color')

  const colors = [
    {name: 'standard', img: require('../assets/img/standard.jpg')},
    {name: 'natürlich', img: require('../assets/img/naturalny.jpg')},
    {name: 'dunkelbraun', img: require('../assets/img/ciemny-braz.jpg')},
  ]

  return (
    <BaseLayout className="summaryScreen">
      <div className="container-fluid ">
        <form onSubmit={handleSubmit(props.onSubmit)}>
          <div className="row justify-content-center">
            <div className="col-lg-8 col-xl-6">
              <div className="mb-4">
                <h2 className="mb-4">Angaben des Auftraggebers:</h2>
                <div>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label>Vorname</label>
                        <input
                          {...register('firstname')}
                          placeholder="Jacek"
                          type="text"
                          className="form-control"
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label>Name</label>
                        <input
                          {...register('lastname')}
                          placeholder="Kowalski"
                          type="text"
                          className="form-control"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-4 col-md-3">
                      <div className="mb-3">
                        <label>Postleitzahl</label>
                        <input
                          {...register('postal', {required: false})}
                          placeholder="00-000"
                          type="text"
                          className="form-control"
                        />
                      </div>
                    </div>
                    <div className="col-sm-8 col-md-9">
                      <div className="mb-3">
                        <label>Stadt</label>
                        <input
                          {...register('city', {required: false})}
                          placeholder="Gdańsk"
                          type="text"
                          className="form-control"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="mb-3">
                    <label>Straße / Ort</label>
                    <input
                      {...register('addressLine1', {required: false})}
                      placeholder="ul. Mickiewicza 21b"
                      type="text"
                      className="form-control"
                    />
                  </div>
                  <div className="mb-3">
                    <label>Telefon</label>
                    <input
                      {...register('phone', {required: true})}
                      placeholder="000 000 000"
                      type="text"
                      className="form-control"
                    />
                    <span style={{fontSize: '0.7em', color: 'var(--bs-danger)'}}>obligatorische Angabe</span>
                  </div>
                  <div className="mb-3">
                    <label>E-Mail</label>
                    <input
                      {...register('email', {required: true})}
                      placeholder="jacekkowalski@pomosty1.pl"
                      type="text"
                      className="form-control"
                    />
                    <span style={{fontSize: '0.7em', color: 'var(--bs-danger)'}}>obligatorische Angabe</span>
                  </div>
                  <div className="mb-3">
                    <label>Montagenadresse</label>
                    <input
                      {...register('customAddress', {required: false})}
                      placeholder="ul. Mickiewicza 51, Kołobrzeg"
                      type="text"
                      className="form-control"
                    />
                  </div>
                  <hr/>
                  <div>
                    <div className="mb-2">Stegfarbe</div>
                    {colors.map((c, idx) => (
                      <div key={idx} className="form-check mb-2" style={{display: 'flex', alignItems: 'center'}}>
                        <input
                          className="form-check-input"
                          type="radio"
                          name="color"
                          value={c.name}
                          id={`color${idx}`}
                          {...register("color", {required: true})}
                        />
                        <label className="form-check-label" htmlFor={`color${idx}`}>
                          <div
                            style={{display: 'inline-block'}}
                            data-tip={`<img src=${c.img} alt="" style="width: 400px; height: 300px; object-fit: contain"/>`}
                            data-effect="solid"
                            data-place="right"
                            data-html={true}
                          >
                            <img src={c.img} alt="" style={{width: 150, height: 100, objectFit: 'cover', paddingLeft: 12}}/>
                          </div>
                          <span style={{paddingLeft: 12}}>{c.name}</span>
                        </label>
                      </div>
                    ))}
                    <div className="form-check" style={{display: 'flex', alignItems: 'center'}}>
                      <input
                        className="form-check-input"
                        type="radio"
                        name="color"
                        value="custom"
                        id={`customColor`}
                        {...register("color", {required: true})}
                      />
                      <label htmlFor="customColor">
                        <span style={{paddingLeft: 12}}>eigene Farbe</span>
                      </label>
                    </div>
                    {color === 'custom' && (
                      <div className="mb-3 pt-2" style={{marginLeft: 24}}>
                        <input
                          {...register('customColor', {required: true})}
                          placeholder="eigene Farbe"
                          type="text"
                          className="form-control"
                        />
                      </div>
                    )}
                  </div>

                  <div className="mb-3">
                    <label>Tipps für den Auftragnehmer / Hersteller</label>
                    <textarea
                      {...register('comments', {required: false})}
                      className="form-control"
                      placeholder="Tipps für den Auftragnehmer / Hersteller"
                      rows="3"
                    />
                  </div>
                  <hr/>
                  <div className="form-check form-check-inline mb-3">
                    <label className="form-check-label">
                      <input type="checkbox" className="form-check-input" checked={props.montazChecked}
                             onChange={props.toggleMontaz}/>
                      Montage in Deutschland (+500 €)
                    </label>
                  </div>
                  <div className="form-check form-check-inline mb-3">
                    <label className="form-check-label">
                      <input type="checkbox" className="form-check-input" checked={props.rejestracjaJednostkiChecked}
                             onChange={props.toggleRejestracjaJednostki}/>
                      Anmeldung des Wasserfahrzeuges und Erledigung aller Formalitäten für den Auftraggeber (+120 €)
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>


          <div className="mb-4">
            <h2 className="mb-4">Zusammenfassung</h2>
            <div>
              <SummaryTable cart={props.cart}/>
            </div>
          </div>

          <div style={{display: 'flex', justifyContent: 'flex-end', columnGap: 5, marginBottom: 20}}>
            <div style={{flex: 1}}>
              <p style={{fontSize: 16, fontWeight: 500}}>Abwicklungsfrist bis 21 Tagen.</p>
            </div>
            <button type="button" className="btn btn-outline-primary" onClick={props.prevStep}
                    disabled={props.processing}>ZURÜCK
            </button>
            <button type="submit" className="btn btn-primary" disabled={props.processing}>ZUM AKZEPT SCHICKEN</button>
          </div>
          <div style={{display: 'flex', justifyContent: 'flex-end', columnGap: 5, marginBottom: 40}}>
            <div style={{flex: 1}}/>
            <div style={{display: 'flex', justifyContent: 'flex-end', columnGap: 5, marginBottom: 40}}>
              {!!props.processing && (
                <div style={{display: 'flex', justifyContent: 'flex-end'}}>
                  <div style={{width: 185, textAlign: 'center'}}>
                    <img src={require('../assets/img/processing.gif')} alt="" style={{width: 40}}/>
                  </div>
                </div>
              )}
              {!!props.error && (
                <div className="text-end text-white badge bg-danger">{props.error}</div>
              )}
            </div>
          </div>


          <div>
            <h4>Ansicht des Planes:</h4>
            <img src={props.planImage} alt="" className="img-fluid"/>
          </div>


        </form>
      </div>
    </BaseLayout>
  )
}